
import React from 'react';
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import logo from "../../assets/logo-aft4.png";
import { COLORS, nameFormatter, priceFormatterV3 } from '../../settings/themeSettings';

const styles = StyleSheet.create({
    page: {
        flexDirection: 'column',
        backgroundColor: 'white',
        paddingVertical: 30,
        paddingHorizontal: 25,
        fontSize: 10
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1
    },
    logoText: {
        fontSize: 12,
        color: 'black',
        paddingLeft: '35px'
    },
    title: {
        fontSize: 12,
        color: 'black',
        fontWeight: 'bold',
        width: '100%',
        height: 20,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 4
    },
    titleRight: {
        fontSize: 10,
        color: 'black',
        fontWeight: 'bold',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: 2
    },
    titleSpan: {
        textTransform: 'uppercase',
        fontSize: 10,
        marginTop: 2
    },
    newtitleStyle: {
        fontSize: 12,
        fontWeight: 'bold',
        textAlign: 'left',
        color: 'black',
        alignSelf: 'flex-start',
        marginVertical: 2,
        paddingHorizontal: 5,
        paddingVertical: 2,
        backgroundColor: COLORS.gray[200],
        borderRadius: 2
    },
    tableHeader: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '100%',
        marginVertical: 2,
        backgroundColor: COLORS.gray[200],
        paddingHorizontal: 5,
        paddingVertical: 2
    },
    tableRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '100%',
        marginHorizontal: 2,
        paddingHorizontal: 5,
        borderBottom: '0.5px solid black',
        marginVertical: 2
    },
    footer: {
        position: 'absolute',
        bottom: 20,
        left: 25,
        right: 25,
        fontSize: 8,
        color: '#666',
        borderTop: '0.5px solid #ccc',
        paddingTop: 4,
        flexDirection: 'row',
        justifyContent: 'space-between'
    }
});






const JournalPDF = ({ data, title, heads, calculateTotal = false, headSubs = {} }) => {
    const now = new Date();
    const dateStr = now.toLocaleDateString('fr-FR');
    const timeStr = now.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
    const editor = 'AFT4 System';

    const calculateColumnWidth = (heads) => {
        const baseWidth = 100 / heads.length;
        return heads.map(() => `${baseWidth}%`);
    };

    const colWidths = calculateColumnWidth(heads);

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    width: '100%',
                    minHeight: 50,
                    padding: 5
                }}>
                    <Image
                        style={{
                            height: 45,
                            width: 100
                        }}
                        source={logo} />
                </View>

                <View style={styles.title}>
                    <Text>{title}</Text>
                    <Text>{dateStr} {timeStr}</Text>
                </View>

                <View style={styles.tableHeader}>
                    {heads?.map((h, index) => (
                        <Text key={index} style={{ width: colWidths[index], fontSize: 10, textAlign: /montant|prix|tarif|depouillement|marge$|CFA$/.test(h) ? 'right' : 'center' }}>
                            {nameFormatter(headSubs.hasOwnProperty(h) ? headSubs[h] : h)}
                        </Text>
                    ))}
                </View>

                {data?.map((d, ikey) => (
                    <View key={ikey} style={styles.tableRow}>
                        {heads?.map((h, key) => {
                            let isprice = /montant|prix|tarif|depouillement|marge$|CFA$/.test(h);
                            return (
                                <Text key={key} style={{ width: colWidths[key], fontSize: 10, padding: 1, textAlign: isprice ? 'right' : 'center' }}>
                                    {isprice ? priceFormatterV3(d[h]) : d[h]}
                                </Text>
                            );
                        })}
                    </View>
                ))}

                {calculateTotal && (
                    <View style={styles.tableRow}>
                        <Text style={{ width: colWidths[0], fontSize: 10, fontWeight: 'bold', textAlign: 'left' }}>Total</Text>
                        <Text style={{ width: colWidths[1], fontSize: 10, textAlign: 'right' }}>
                            {priceFormatterV3(data.reduce((a, b) => a + b.montant, 0))}
                        </Text>
                        <Text style={{ width: colWidths[2], fontSize: 10, textAlign: 'right' }}>
                            {priceFormatterV3(data.reduce((a, b) => a + (b.prix || b.depouillement), 0))}
                        </Text>
                    </View>
                )}

                <View style={styles.footer}>
                    <Text>Édité par {editor}</Text>
                    <Text render={({ pageNumber, totalPages }) => `Page ${pageNumber} / ${totalPages}`} />
                </View>
            </Page>
        </Document>
    );
};


export default JournalPDF;
